module.exports = __webpack_public_path__ + "img/certificate-1.7e90d09e.png";